import { WidgetGallery } from '../../../../common/types/api/page'

export const MAX_WIDTH = 900
export const HEIGHT_ROW =  8
export const magicNumber = 1.9

const getW = (width: number): number => Math.floor((width / MAX_WIDTH) * 100)
const getH = (height: number): number => Math.round(height / (HEIGHT_ROW * magicNumber))

/**
 *
 * @param widgetsMatrix - this is a matrix. Each element in the first level of the array
 * represente a different row Ex. [row, row, row]. Each row is an array of colums for that row
 * EX. row = [column, column, column]
 * @param editMode
 * @returns
 */


export function getGalleryLayout(widgetsMatrix: WidgetGallery[][], editMode: boolean): LayoutGrid[] {
    if (!Array.isArray(widgetsMatrix)) return []

    let layout = [] as LayoutGrid[]
    if (!widgetsMatrix.length && editMode) {
        layout = [getDefaultCellConfigs()]

        return layout
    }
    // TODO: RESOLVE
    widgetsMatrix.reduce(
        (state, row, columnIndex) => {
            if (!row || !Array.isArray(row)) return state

            const maxRowSize = getMaxSizeOfRow(row)
            const gridRowLayout = getLayoutForGridRow(row, maxRowSize, columnIndex, editMode, state.totalHeight)
            layout = [...layout, ...gridRowLayout]

            if (editMode && columnIndex + 1 === widgetsMatrix.length) {
                const newColumnAddBtn = getDefaultCellConfigs()
                newColumnAddBtn.grid.i = `widget-${columnIndex + 1}-${0}`
                newColumnAddBtn.grid.y =
                    Math.floor((state.totalHeight + maxRowSize.height) / (HEIGHT_ROW * magicNumber)) + 1
                newColumnAddBtn.indexCol = columnIndex + 1

                layout.push(newColumnAddBtn)
            }

            return {
                totalHeight: state.totalHeight + maxRowSize.height + HEIGHT_ROW
            }
        },
        { totalHeight: 0 }
    )

    return layout
}

function getLayoutForGridRow(row, maxRowSize, columnIndex, editMode, totalHeight): LayoutGrid[] {
    return row.reduce((rowLayout, widgetRow, indexRow) => {
        const widgetWidth = getW(widgetRow.width)
        const WidthFreeSpace = 100 - Math.floor((maxRowSize.widthTotal / MAX_WIDTH) * 100)
        const widgetHeight = Math.round(widgetRow.height / (HEIGHT_ROW * magicNumber))
        const widgetX = rowLayout[indexRow - 1]?.grid.x || 0
        const rowY = Math.round(totalHeight / (HEIGHT_ROW * magicNumber))
        const maxWidth = widgetWidth + WidthFreeSpace
        const widgetConfigs = {
            grid: {
                i: `widget-${columnIndex}-${indexRow}`,
                maxW: maxWidth,
                x: widgetX + rowLayout[indexRow - 1]?.grid.w || 0,
                y: rowY,
                w: widgetWidth,
                h: widgetHeight,
                static: false,
                isResizable: editMode
            },
            widget: widgetRow,
            isAdd: false,
            indexCol: columnIndex,
            indexRow: indexRow,
            widthMax: MAX_WIDTH - maxRowSize.widthTotal + widgetRow.width
        }
        rowLayout.push(widgetConfigs)

        // if element is the last in array and there is still available space
        // creates a button to add a new element in that row
        if (editMode && indexRow + 1 === row.length && WidthFreeSpace >= 25) {
            const rowAddBtn = getDefaultCellConfigs()
            rowAddBtn.grid.i = `widget-${columnIndex}-${indexRow + 1}`
            rowAddBtn.grid.x = widgetX + widgetWidth * 2
            rowAddBtn.grid.y = rowY
            rowAddBtn.grid.maxW = maxWidth
            rowAddBtn.grid.h = getH(maxRowSize.height)
            rowAddBtn.widget.height = maxRowSize.height
            rowAddBtn.widget.id = 123
            rowAddBtn.indexRow = indexRow + 1
            rowAddBtn.indexCol = columnIndex
            rowLayout.push(rowAddBtn)
        }

        return rowLayout
    }, [])
}

function getMaxSizeOfRow(row: WidgetGallery[]): { height: number; width: number; widthTotal: number } {
    return row.reduce(
        (acc, widgetRow) => ({
            height: Math.max(widgetRow.height, acc.height),
            width: Math.max(widgetRow.width, acc.width),
            widthTotal: widgetRow.width + acc.widthTotal
        }),
        { height: 0, width: 0, widthTotal: 0 }
    )
}

export function getDefaultCellConfigs(): LayoutGrid {
    return {
        grid: {
            i: 'default',
            maxW: 100,
            
            x: 0,
            y: 0,
            w: getW(225),
            h: getH(300),
            static: false,
            isResizable: false
        },
        widget: {
            width: 225,
            height: 300,
            id: 100,
            showSpan: false,
            showTitle: true,
            span: 'last hour',
            widgetId: 0,
            unfollowSpan:false,
            titlePosition:'center'
        },
        isAdd: true,
        indexRow: 0,
        indexCol: 0,
        widthMax: 0
    }
}
